import React, { useEffect, useRef, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { getAuthorizationToken } from '../../../../../lib/access.es6'
import { getEnvironmentInformation } from '../../../../../lib/utils.es6'
import { getUssdOrgUuid } from '../../../../../lib/ussdSessionsRequests.es6'
import { loadVendorBundle } from '../vendorBundle'

function ussdSessionsBaseUrl() {
  const env = getEnvironmentInformation()
  return env ? env.servicesURLs.ussdSessions : 'http://localhost:8090/'
}

export default function Simulator({ flowUuid, msisdn }) {
  const ref = useRef(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false
    loadVendorBundle().then(() => {
      if (!cancelled) setReady(true)
    })
    return () => {
      cancelled = true
    }
  }, [])

  useEffect(() => {
    if (!ready || !ref.current) return
    const el = ref.current
    let cancelled = false
    getUssdOrgUuid().then(org => {
      if (cancelled) return
      el.fixedEndpoint = `${ussdSessionsBaseUrl()}mr/business/simulate/start?org=${org}`
      el.authToken = getAuthorizationToken()
      el.customerMsisdn = msisdn
      el.flow = flowUuid

      // there's no floating tab for a business user to click here (unlike the flow editor, where a
      // real person clicks it) - wait for the element's first render (it needs its own shadow DOM to
      // exist before handleShow can find the phone window inside it), then open the drawer and start
      // the flow ourselves.
      el.updateComplete.then(() => el.handleShow())
    })
    return () => {
      cancelled = true
    }
  }, [ready, flowUuid, msisdn])

  if (!flowUuid || !msisdn) {
    return (
      <Typography variant="body2">
        Choose a flow and a customer to simulate.
      </Typography>
    )
  }

  if (!ready) {
    return <Typography variant="body2">Loading simulator…</Typography>
  }

  return (
    <Box sx={{ position: 'relative' }}>
      {/* temba-simulator (and other temba-components internals, e.g. handleShow's
          getStore().getState()) expect exactly one <temba-store> mounted somewhere on the page - in
          RapidPro's own Django templates this is rendered globally once; webclient has no equivalent, so
          it's mounted here instead. Safe with no attributes set - every one of its own fetches is gated
          behind its own endpoint attribute being present (see Store.ts's reset()). */}
      {/* eslint-disable-next-line react/no-unknown-property */}
      <temba-store />
      {/* eslint-disable-next-line react/no-unknown-property */}
      <temba-simulator ref={ref} />
    </Box>
  )
}
